import React from 'react';
import {graphql, useStaticQuery} from 'gatsby';
import ListProducts from '../../components/ListProducts';
import Categories from '../../components/Categories';

const Products = props => {
  const data = useStaticQuery(graphql`
    query BlockProductsQuery {
      allMdx(
        filter: {
          frontmatter: {active: {ne: false}}
          fileAbsolutePath: {regex: "/(/products/)/"}
        }
        sort: {fields: frontmatter___title}
      ) {
        nodes {
          ...ProductList
        }
      }
    }
  `);
  return (
    <>
      <Categories data={data} />
      <ListProducts data={data} />
    </>
  );
};

export default Products;
